import React, { useState } from "react";
import { Button, Modal, Form, Input, notification } from "antd";
import { NewSaveLeadForSales } from "../request/apiRquest";

// Custom download with notification
const downloadPDF = async (brochureUrl) => {
  try {
    // notification.info({
    //   message: "Download Started",
    //   description: "Your brochure download is starting...",
    //   placement: "topRight",
    // });

    const response = await fetch(brochureUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = brochureUrl.split("/").pop(); // filename
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    notification.success({
      message: "Download Complete",
      description: "Your brochure has been downloaded successfully.",
      placement: "bottomLeft",
    });
  } catch (error) {
    notification.error({
      message: "Download Failed",
      description: "There was an issue downloading the brochure.",
      placement: "topRight",
    });
  }
};

const BrochurePropertyDetails = ({ download_link }) => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => setOpen(true);
  const closeModal = () => setOpen(false);
  const handleCancel = () => setOpen(false);

  const handleOk = () => {
    try {
      form
        .validateFields()
        .then((values) => {
          const payload = {
            contactNo: values.contactNumber || "",
            email: values.email || "",
            expectedRevenue: values.expectedRevenue || 0,
            firstName: values.firstName || "",
            pipelineName: values.pipelineName || "Trinestsky Website Leads",
            leadSource: values.leadSource || "trinestsky.com",
            leadType: values.leadType || "Sales",
            pipelineStageId: values.pipelineStageId || 0,
            priority: values.priority || "medium",
            productId: values.productId || 31,
            remark: values.description || "",
          };

          // Save API call
          NewSaveLeadForSales(payload);

          // Trigger actual brochure PDF download after saving
          if (download_link) {
            downloadPDF(download_link);
          }

          // Close modal + reset form
          setOpen(false);
          form.resetFields();
        })
        .catch((info) => {
          console.log("Validate Failed:", info);
        });
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  return (
    <>
      <button
        onClick={showModal}
          style={{
            background:
              "linear-gradient(90deg, #FEA928 0%, #FFBF57 100%)",
            color: "#fff",
            border: "none",
            padding: "15px 40px",
            borderRadius: "12px",
            fontWeight: "600",
            fontSize: "clamp(14px, 2vw, 17px)",
            cursor: "pointer",
            boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
            transition: "all 0.3s ease",
            width: "100%",
            maxWidth: "280px",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(90deg, #fda94f 0%, #fda94f 100%)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background =
              "linear-gradient(90deg, #fda94f 0%, #fda94f 100%)")
          }
        >
          <i className="fa fa-download" style={{ marginRight: "10px" }}></i>
          Download Brochure
          
        </button>

      <Modal
        title="Download Brochure"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit & Download"
        okButtonProps={{
          style: {
            backgroundColor: "#fda94f",
            borderColor: "#fda94f",
            color: "#fff",
          },
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="brochureForm"
          initialValues={{
            firstName: "",
            email: "",
            contactNumber: "",
            description: "",
          }}
        >
          <Form.Item
            label="Full Name"
            name="firstName"
            rules={[
              { required: true, message: "Please enter your Name!" },
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve(); // required rule will handle empty
                  }
                  if (/\s/.test(value.trim())) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Please enter your full name ")
                  );
                },
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your Email!" },
              { type: "email", message: "Please enter a valid Email!" },
            ]}
          >
            <Input
              onChange={(e) => {
                const lowercaseValue = e.target.value.toLowerCase();
                form.setFieldsValue({ email: lowercaseValue });
              }}
            />
          </Form.Item>

          <Form.Item
            label="Contact Number"
            name="contactNumber"
            rules={[
              { required: true, message: "Please enter your Contact Number!" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            rules={[
              { required: true, message: "Please enter your Description!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default BrochurePropertyDetails;

